import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrNotificationClient } from '../../../../../../shared/types/modules/pqr';

export const usePqrNotificationClient = (
    notificationClient?: PqrNotificationClient
) => {
    const formik = useFormik({
        initialValues: {
            email: '',
            phone: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { email, phone } = notificationClient || {};

        formik.setValues({
            email: email || '',
            phone: phone || '',
        });
    }, [notificationClient]);

    return {
        formik,
    };
};
